import {
  aChainRule,
  aCreateChainRule,
  mockCreateChainRuleBuilderOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import {
  CHAIN_RULE_DATA,
  ruleBuilderQuery_chain,
} from '../queries/RuleBuilderQueryOperation.mocks';

export const createChainRuleResponse = {
  __typename: 'Mutation' as const,
  createChainRule: aCreateChainRule({
    data: {
      ...aChainRule({
        ...ruleBuilderQuery_chain.rule,
      }),
      // @ts-ignore windowSizeInMilliseconds is aliased which causes issues with typing since MSW doesn't handle this case
      windowSizeMilliseconds: CHAIN_RULE_DATA.windowSizeMilliseconds,
    },
  }),
};

export const handlers = [
  mockCreateChainRuleBuilderOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        // @ts-ignore windowSizeInMilliseconds is aliased which causes issues with typing since MSW doesn't handle this case
        data: createChainRuleResponse,
      });
    }
  ),
];
